<template>
  <table class="legend">
    <tr v-for="number in getTrCount" :key="`tr-${number}`">
      <td v-for="index in forSize(number)" :key="`td-${index+((number -1) * 5)}`"
      :width="`${Math.floor(100/objTypeInfo.length)}%`" :style="(objTypeInfo.length > 4) ? 'text-align: left' : 'text-align: center'">
        {{ getObjTypeInfo(index, number, 'cnt') }}
        <span>{{ getObjTypeInfo(index, number, 'label') }}</span> </td>
    </tr>
  </table>
</template>

<script>
import isNil from 'lodash/isNil';
import { EMPTY_TEXT } from '@/utils/string';

export default {
  name: 'WSummaryCofigLegend',
  props: {
    objTypeInfo: {
      type: Array,
    },
  },
  computed: {
    /**
     * 데이터 수에 따른 tr 반복 횟수를 설정
     * @author leesy918
     * @return {[type]} [description]
     */
    getTrCount() {
      if (isNil(this.objTypeInfo)) {
        return 0;
      }
      const mock = Math.ceil(this.objTypeInfo.length / 5);
      return (this.objTypeInfo.length >= 5) ? mock : 1;
    },
  },
  methods: {
    /**
     * 관리대상의 정보를 배열에서 가져온다
     * @author leesy918
     * @param  {[type]} index  [td의 순번]
     * @param  {[type]} number [tr의 순번]
     * @param  {[type]} key    [가져올 데이터 이름]
     * @return {[type]}        [description]
     */
    getObjTypeInfo(index, number, key) {
      if (isNil(this.objTypeInfo)) {
        return EMPTY_TEXT;
      }
      const info = this.objTypeInfo[(index - 1) + ((number - 1) * 5)];
      return info[key];
    },
    /**
     * 데이터 수에 따른 td 반복 횟수 설정
     * @author leesy918
     * @param  {[type]} number [description]
     * @return {[type]}        [description]
     */
    forSize(number) {
      if (isNil(this.objTypeInfo)) {
        return 0;
      }
      const lastNumber = Math.ceil(this.objTypeInfo.length / 5);
      if (number === lastNumber) {
        return this.objTypeInfo.length - ((lastNumber - 1) * 5);
      }
      return (this.objTypeInfo.length < 5) ? this.objTypeInfo.length % 5 : 5;
    },
  },
};
</script>

<style lang="scss" scoped>
.legend {
  width: 77%;
  color: #2a2d88;
  font-size: 12px;
  tr {
    padding-bottom: 14px;
    &:last-child {padding-bottom: 0}
    td {
      white-space:nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 150px;
      span {margin-left: 3px; font-weight: 600}
      &:before {
        content:'';
        width: 3px;
        height: 3px;
        border-radius: 50%;
        display: inline-block;
        background: #b4b7c3;
        margin-right: 5px;
        position: relative;
        top:-2px
      }
    }
  }
}
@media only screen and (max-width: 1750px) {
  .legend {margin: 0}
  }
  @media only screen and (max-width: 1670px) {
    .legend {margin: 0}

  }
</style>



// WEBPACK FOOTER //
// src/views/performance/root/components/SummaryCofigLegend.vue